import { BrowserRouter } from 'react-router-dom'
import { AppRoutes } from './router'
import { AdminProvider } from './contexts/AdminContext'
import { ToastProvider } from './components/ui/toast-provider'


function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <AdminProvider>
        <ToastProvider>
      <AppRoutes />
        </ToastProvider>
      </AdminProvider>
    </BrowserRouter>
  )
}

export default App